<template>
  <div class="presupuestos-gastos-comparativo">
    <b-row>
      <b-col cols="12" xl="12">  
        <b-card header="Presupuestos de Gastos">
          <b-table hover
              responsive="sm" 
              class="registro"
              :busy="tableBusy"
              :items="comparativoRenglones" 
              :fields="fields">
            <div slot="table-busy" class="text-center">
              <b-spinner class="table-spinner" label="Spinning" />
            </div>
            <template v-slot:head(importeAnterior)>
              {{ comparativoPeriodoAnterior | periodo }}
            </template>
            <template v-slot:head(importeActual)>
              {{ comparativoPeriodoActual | periodo }}
            </template>
            <template v-slot:head(importePosterior)>
              {{ comparativoPeriodoPosterior | periodo }}
            </template>
            <template v-slot:cell(importeAnterior)="data">
              {{ data.item.importeAnterior | moneda }}
            </template>
            <template v-slot:cell(importeActual)="data">
              {{ data.item.importeActual | moneda }}
            </template>
            <template v-slot:cell(pjeIncrementoActual)="data">
              {{ data.item.pjeIncrementoActual | porcentaje }}
            </template>
            <template v-slot:cell(importePosterior)="data">
              {{ data.item.importePosterior | moneda }}
            </template>
            <template v-slot:cell(pjeIncrementoPosterior)="data">
              {{ data.item.pjeIncrementoPosterior | porcentaje }}
            </template>
          </b-table>
        </b-card>
      </b-col>
    </b-row>

    <div class="fixed-btn">
      <div class="list-dropdown-btn">
        <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
          <template slot="button-content">
            <i class="fa fa-ellipsis-v fa-2x" aria-hidden="true"></i>
          </template>
          
          <b-dropdown-item @click.stop="goBack">
            <i class="fa fa-undo"></i>Volver al Listado</b-dropdown-item>
        </b-dropdown>
      </div>
    </div>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'presupuestosGastos/getField',
  mutationType: 'presupuestosGastos/updateField',
});

export default {
  name: 'PresupuestosGastosComparativo',
  components: {
    appMensaje: Mensaje,
  },
  mixins: [ 
    msjModal, 
  ],
  data: () => {
    return {
      fields: [
        {
          key: 'presupuestoGastosConcepto',
          label: 'Concepto'
        },
        {
          key: 'importeAnterior',
          // label: 'Total',
          class:'text-right'
        },
        {
          key: 'importeActual',
          // label: 'Total',
          class:'text-right'
        },
        {
          key: 'pjeIncrementoActual',
          label: '',
          class:'text-right'
        },
        {
          key: 'importePosterior',
          // label: 'Total',
          class:'text-right'
        },
        {
          key: 'pjeIncrementoPosterior',
          label: '',
          class:'text-right'
        },
      ],

      tableBusy: false,
    }
  },
  computed: {
    ...mapFields([
      'comparativoPeriodoAnterior',
      'comparativoPeriodoActual',
      'comparativoPeriodoPosterior',
      'comparativoRenglones'      
    ]),
  },
  created() {
    this.getComparativo();
  },  
  methods: {
    getComparativo() {
      this.tableBusy = true;
      this.$store.dispatch('presupuestosGastos/getPresupuestosGastosComparativo')
        .then(() => this.tableBusy = false)
        .catch(error => this.showErrorMsj(error));
    },
    goBack() {
      this.$router.push({ name: 'PresupuestosGastos' }); 
    },
  },
}
</script>

<style>
  .presupuestos-gastos-comparativo table td {
    padding-top: 5px;
    padding-bottom: 5px;
    vertical-align: middle;
  }
  .presupuestos-gastos-comparativo table td[aria-colindex="1"] {
    width: 45%;
  }
  .presupuestos-gastos-comparativo table td[aria-colindex="2"] {
    width: 15%;
  }
  .presupuestos-gastos-comparativo table td[aria-colindex="3"] {
    width: 15%;
  }
  .presupuestos-gastos-comparativo table td[aria-colindex="4"] {
    width: 5%;
    font-size: 0.9em;
    /* color: blue; */
  }
  .presupuestos-gastos-comparativo table tr.table-v-n td[aria-colindex="4"],
  .presupuestos-gastos-comparativo table tr.table-v-r td[aria-colindex="4"],
  .presupuestos-gastos-comparativo table tr.table-v-v td[aria-colindex="4"] {
    color: green;
  }
  .presupuestos-gastos-comparativo table tr.table-r-n td[aria-colindex="4"],
  .presupuestos-gastos-comparativo table tr.table-r-r td[aria-colindex="4"],
  .presupuestos-gastos-comparativo table tr.table-r-v td[aria-colindex="4"] {
    color: red;
  }

  .presupuestos-gastos-comparativo table td[aria-colindex="5"] {
    width: 15%;
  }
  .presupuestos-gastos-comparativo table td[aria-colindex="6"] {
    width: 5%;
    font-size: 0.9em;
    /* color: blue; */
  }
  .presupuestos-gastos-comparativo table tr.table-n-v td[aria-colindex="6"],
  .presupuestos-gastos-comparativo table tr.table-r-v td[aria-colindex="6"],
  .presupuestos-gastos-comparativo table tr.table-v-v td[aria-colindex="6"] {
    color: green;
  }
  .presupuestos-gastos-comparativo table tr.table-n-r td[aria-colindex="6"],
  .presupuestos-gastos-comparativo table tr.table-r-r td[aria-colindex="6"],
  .presupuestos-gastos-comparativo table tr.table-v-r td[aria-colindex="6"] {
    color: red;
  }

  .presupuestos-gastos-comparativo table tr.table-totales {
    font-weight: 700;
  }
</style>
